// extracted by mini-css-extract-plugin
export var fadeIn = "_kw-1";
export var modalContent = "_kw-3";
export var overlay = "_kw-0";
export var popoverContent = "_kw-2";
export var results = "_kw-5";
export var searchInputWrapper = "_kw-4";